export const testimonialData = [
  {
    id: 1,
    name: "Katherine S",
    time: "2025-03-26",
    remark: "",
    title: "Metabolic Assessment",
    text: "As a busy mom of three, I tried countless diets without success. ProxyMed's medical approach was completely different. The personalized plan considered my thyroid condition, and the medical team's support made all the difference. My energy levels are through the roof, and I'm finally able to keep up with my kids!",
  },
  {
    id: 2,
    name: "Jeff C",
    time: "2025-04-18",
    remark: "",
    title: "Hormonal Balance",
    text: "After my heart attack scare, I knew I needed a medically supervised program. ProxyMed's careful monitoring and gradual approach helped me lose weight safely. My cardiologist is amazed at the improvement in my heart health markers.",
  },
  {
    id: 3,
    name: "Katherine S",
    time: "2025-03-26",
    remark: "",
    title: "Nutritional Science",
    text: "As a busy mom of three, I tried countless diets without success. ProxyMed's medical approach was completely different. The personalized plan considered my thyroid condition, and the medical team's support made all the difference. My energy levels are through the roof, and I'm finally able to keep up with my kids!",
  },
  {
    id: 4,
    name: "Jeff C",
    time: "2025-04-18",
    remark: "",
    title: "Behavioral Psychology",
    text: "After my heart attack scare, I knew I needed a medically supervised program. ProxyMed's careful monitoring and gradual approach helped me lose weight safely. My cardiologist is amazed at the improvement in my heart health markers.",
  },
  {
    id: 5,
    name: "Katherine S",
    time: "2025-03-26",
    remark: "",
    title: "Behavioral Psychology",
    text: "As a busy mom of three, I tried countless diets without success. ProxyMed's medical approach was completely different. The personalized plan considered my thyroid condition, and the medical team's support made all the difference. My energy levels are through the roof, and I'm finally able to keep up with my kids!",
  },
  {
    id: 6,
    name: "Jeff C",
    time: "2025-04-18",
    remark: "",
    title: "Behavioral Psychology",
    text: "After my heart attack scare, I knew I needed a medically supervised program. ProxyMed's careful monitoring and gradual approach helped me lose weight safely. My cardiologist is amazed at the improvement in my heart health markers.",
  },
  {
    id: 7,
    name: "Katherine S",
    time: "2025-03-26",
    remark: "",
    title: "Behavioral Psychology",
    text: "As a busy mom of three, I tried countless diets without success. ProxyMed's medical approach was completely different. The personalized plan considered my thyroid condition, and the medical team's support made all the difference. My energy levels are through the roof, and I'm finally able to keep up with my kids!",
  },
  {
    id: 8,
    name: "Jeff C",
    time: "2025-04-18",
    remark: "",
    title: "Behavioral Psychology",
    text: "After my heart attack scare, I knew I needed a medically supervised program. ProxyMed's careful monitoring and gradual approach helped me lose weight safely. My cardiologist is amazed at the improvement in my heart health markers.",
  },
];
